// IconStrava.tsx
import React from "react";

type Props = {
    className?: string;
};

const IconStrava: React.FC<Props> = ({ className }) => {
    return (
        <svg
            className={className}
            width="30"
            height="30"
            viewBox="0 0 256 256"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
        >
            <polygon points="128,42 78,150 178,150" fill="currentColor" />
            <polygon points="116,150 196,150 156,236" fill="currentColor" opacity="0.45" />
        </svg>
    );
};

export default IconStrava;
